import { CSS, StyleProps } from "../../../styles"

export const legend = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(4),
  marginRight: props.theme.spacing(8),
  [props.theme.breakPoints.xxxl.up]: {
    marginRight: 0,
  },
  "& ul": {
    display: `flex`,
    paddingLeft: 0,
    margin: 0,
    marginLeft: props.theme.spacing(3),
    listStyle: `none`,
    "& li": {
      display: `inline`,
      whiteSpace: `pre`,
      "&:not(:first-child)": {
        paddingLeft: props.theme.spacing(1),
        "&:before": {
          content: `"•"`,
          marginRight: props.theme.spacing(1),
        },
      },
    },
  },
})

export const bold = (props: StyleProps) => ({
  ...props.theme.fonts.subHeading,
})
